import { QuestionCircleOutlined } from '@ant-design/icons';
import { Checkbox, Tooltip } from 'antd';
import { HTMLAttributes } from 'react';
import { PlatformProps } from './share';
import { useTranslate } from '@tolgee/react';

interface FilterNegativeBuyerProps extends PlatformProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  scenarioType: Marketing.AllScenarioType;
  className?: HTMLAttributes<HTMLDivElement>['className'];
}

// 过滤易差评买家支持场景 PD: https://leyan.yuque.com/czpqnb/pd/ymaah33w2l0uqn85#ZYoV7
export const isFilterNegativeBuyerScenarioSupport = (
  scenarioType: Marketing.AllScenarioType,
  platform: PlatformProps['platform'],
) => {
  // 支持平台: Shopee Lazada
  // 支持场景：除[中差评挽回]、[差评回评]以外全部场景。（进店欢迎语、超时自动回复也支持）
  return (
    (platform === 'SHOPEE' || platform === 'LAZADA') &&
    scenarioType !== 'NEGATIVE_REVIEW_REPLY' &&
    scenarioType !== 'NEGATIVE_REVIEW_SAVE'
  );
};

// 默认设置 催好评场景：勾选[过滤易差评买家]
export const getFilterNegativeBuyerDefault = (scenarioType: Marketing.AllScenarioType) => {
  return scenarioType === 'PRAISE_REMINDER';
};

export const FilterNegativeBuyer = (props: FilterNegativeBuyerProps) => {
  const { platform, scenarioType, checked, onChange, className } = props;
  const { t } = useTranslate();

  return isFilterNegativeBuyerScenarioSupport(scenarioType, platform) ? (
    <div className={className}>
      <Checkbox
        checked={checked}
        onChange={({ target: { checked } }) => {
          onChange(checked);
        }}
      >
        {t('ai_task_form_filter_negative_buyer')}
        <Tooltip title={t('ai_task_form_filter_negative_buyer_tips')}>
          <QuestionCircleOutlined className="ml-1" />
        </Tooltip>
      </Checkbox>
    </div>
  ) : null;
};
